export type { actionType, IBaseStateProps } from '../../../ActionTypes';

export const CUSTOM_FIELDS_TYPES = {
  FETCH: 'CUSTOM_FIELDS_TYPES_GET',
  SUCCESS: 'CUSTOM_FIELDS_TYPES_SUCCESS',
  FAIL: 'CUSTOM_FIELDS_TYPES_FAIL'
};
